import { Skeleton } from '~shared/ui/atoms/Skeleton';

import { Images, Info } from '../styles';
import { GridItemWrapper, OtherContentSkeleton } from './styles';

export const GridItemSkeleton = () => (
	<GridItemWrapper>
		<Images>
			<Skeleton />
		</Images>
		<Info>
			<OtherContentSkeleton className="skeleton" />
		</Info>
	</GridItemWrapper>
);
